var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var RbGtmClient = /** @class */ (function () {
    function RbGtmClient(args) {
        this._userProperties = args.userProperties;
        window.dataLayer = window.dataLayer || [];
    }
    Object.defineProperty(RbGtmClient.prototype, "userProperties", {
        get: function () {
            return this._userProperties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Extend the user properties with new values.
     * When GTM client is initialised a set of default user properties get
     * pushed to the datalayer. They can be extended based on requirements on
     * individual pages.
     */
    RbGtmClient.prototype.extendUserProperties = function (newUserProperties) {
        this._userProperties = __assign(__assign({}, this._userProperties), newUserProperties);
    };
    RbGtmClient.track = function (payload) {
        window.dataLayer = window.dataLayer || [];
        if (Object.keys(payload).includes('ecommerce')) {
            window.dataLayer.push({ ecommerce: null });
        }
        window.dataLayer.push(payload);
    };
    return RbGtmClient;
}());
export { RbGtmClient };
